import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-inputnumbers',
  templateUrl: './inputnumbers.component.html',
  styleUrls: ['./inputnumbers.component.scss']
})
export class InputnumbersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
